/**
 * Type definitions for Tangor Connector API (Corporate Actions Service)
 * Source: services/corporate_actions/protos/coinbase/corporate_actions/
 */

export enum Brokerage {
  BROKERAGE_UNSPECIFIED = 0,
  BROKERAGE_APEX = 1,
}

export enum CorporateActionType {
  CORPORATE_ACTION_TYPE_UNSPECIFIED = 0,
  CORPORATE_ACTION_TYPE_CASH_DIVIDEND = 1,
  CORPORATE_ACTION_TYPE_STOCK_DIVIDEND = 2,
  CORPORATE_ACTION_TYPE_STOCK_SPLIT = 3,
  CORPORATE_ACTION_TYPE_REVERSE_STOCK_SPLIT = 4,
}

export enum CorporateActionStatus {
  CORPORATE_ACTION_STATUS_UNSPECIFIED = 0,
  CORPORATE_ACTION_STATUS_CREATED = 1,
  CORPORATE_ACTION_STATUS_ANNOUNCED = 2,
  CORPORATE_ACTION_STATUS_COMPLETED = 3,
  CORPORATE_ACTION_STATUS_CANCELED = 4,
}

export enum CorporateActionOrderBy {
  CORPORATE_ACTION_ORDER_BY_UNSPECIFIED = 0,
  CORPORATE_ACTION_ORDER_BY_EXECUTION_DATE_ASC = 1,
  CORPORATE_ACTION_ORDER_BY_EXECUTION_DATE_DESC = 2,
}

export enum DividendType {
  DIVIDEND_TYPE_UNSPECIFIED = 0,
  DIVIDEND_TYPE_CASH = 1,
  DIVIDEND_TYPE_STOCK = 2,
  DIVIDEND_TYPE_CASH_AND_STOCK = 3,
}

export type CoinbaseSecurity = {
  cbrn: string;
};

export type Timestamp = {
  seconds: string;
  nanos: number;
};

export type CashDividend = {
  amount: string;
  payout_date: Timestamp;
  security: CoinbaseSecurity;
};

export type StockDividend = {
  amount: string;
  paid_date: Timestamp;
  security: CoinbaseSecurity;
};

export type StockSplit = {
  ratio: string;
  effective_date: Timestamp;
  security: CoinbaseSecurity;
};

export type ReverseStockSplit = {
  ratio: string;
  effective_date: Timestamp;
  security: CoinbaseSecurity;
};

export type CorporateActionDetails = {
  cash_dividend?: CashDividend;
  stock_dividend?: StockDividend;
  stock_split?: StockSplit;
  reverse_stock_split?: ReverseStockSplit;
};

export type CorporateAction = {
  id: string;
  brokerage: Brokerage;
  brokerage_ref: string;
  action_type: CorporateActionType;
  brokerage_created_at: Timestamp;
  state: CorporateActionStatus;
  details: CorporateActionDetails;
};

export type ListCorporateActionsRequest = {
  brokerage?: Brokerage;
  security?: CoinbaseSecurity;
  page_token?: string;
  page_size?: number;
  statuses?: CorporateActionStatus[];
  action_types?: CorporateActionType[];
  order_by?: CorporateActionOrderBy;
  securities?: CoinbaseSecurity[];
};

export type ListCorporateActionsResponse = {
  corporate_actions: CorporateAction[];
  next_page_token: string;
};

export type DividendPayout = {
  corporate_action_id: string;
  recipient_address: string;
  amount: string;
  cbrn: string;
  amount_wei: string;
  holder_balance: string;
  holder_balance_wei: string;
  /** Comes as a string enum name from proto-loader (e.g. "DIVIDEND_TYPE_CASH") */
  dividend_type: string;
  paid_at: Timestamp | null;
};

export type ListDividendPayoutsRequest = {
  corporate_action_ids?: string[];
  recipient_address?: string;
  dividend_types?: DividendType[];
  page_token?: string;
  page_size?: number;
};

export type ListDividendPayoutsResponse = {
  dividend_payouts: DividendPayout[];
  next_page_token: string;
};
